<i18n src="@/locales/modules/DeviceAccessoryTranslate.json"></i18n>

<template>
	<el-dialog id="reset-kpi-dialog" class="custom-confirm-dialog" destroy-on-close :show-close="false" :visible.sync="isDialogActiveLocal" :title="$t('Actions.Reset')">
		<div>
			<label>
				{{ $t("InputReasonResetKpiHour") }}
				<span class="text-danger">*</span>:
			</label>
			<cbs-textarea class="mt-2" type="textarea" name="reason-reject" v-model="reason" v-validate="'required'" :rows="3" :data-vv-as="$t('InputReasonResetKpiHour')" />
			<span class="text-danger text-sm" v-show="errors.has('reason-reject')">{{ errors.first("reason-reject") }}</span>
		</div>

		<div class="flex justify-end -mx-6" slot="footer">
			<vs-button text-color="#828282" type="flat" class="w-1/3 font-bold mr-3" @click.stop="$emit('closeDialog')">{{ $t("Actions.Cancel") }}</vs-button>

			<vs-button class="w-1/3 font-bold " @click.stop="confirmReject" color="danger">
				{{ $t("Actions.Confirm") }}
			</vs-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "KpiResetHour",
	props: {
		isDialogActive: {
			type: Boolean,
			required: true
		}
	},
	emits: {
		closeDialog: {},
		onClickAgree: {}
	},
	data() {
		return {
			reason: ""
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog", false);
				}
			}
		}
	},
	watch: {
		isDialogActiveLocal() {
			if (!this.isDialogActiveLocal) {
				this.reason = "";
			}
		}
	},
	methods: {
		confirmReject() {
			this.$validator.validateAll().then(validateionResult => {
				if (!validateionResult) return;
				this.$emit("onClickAgree", this.reason);
			});
		}
	}
};
</script>

<style lang="scss">
#reset-kpi-dialog {
	::v-deep .el-dialog {
		width: 510px;
		max-width: unset;
	}
}
</style>
